import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { ShowTvDetailEvent } from 'app/common/eventbus/Events';
import { NMUI4DContext } from 'app/common/context/NMUI4DContext';
import { ModalHandler } from 'app/components/panels/ModalHandler';

import { UnityCanvas } from './UnityCanvas';
import { VuplexIntegration } from './VuplexIntegration';
import { AirspaceDetailRequestedNotification } from './ContentViewerTypes/AirspaceDetailRequestedNotification';
import { FlightDetailRequestedNotification } from './ContentViewerTypes/FlightDetailRequestedNotification';
import { MeasureDetailRequestedNotification } from './ContentViewerTypes/MeasureDetailRequestedNotification';

type TProps = {
    customControls?: ReactNode;
};

export const UnityApplication = (props: React.PropsWithChildren<TProps>) => {
    const [isLoaded, setIsLoaded] = useState(false);

    const context = useContext(NMUI4DContext);

    useEffect(() => {
        interface IAirspaceDetailRequestedNotification {
            type: 'AirspaceDetailRequestedNotification';
            data: AirspaceDetailRequestedNotification;
        }
        interface IFlightDetailRequestedNotification {
            type: 'FlightDetailRequestedNotification';
            data: FlightDetailRequestedNotification;
        }
        interface IMeasureDetailRequestedNotification {
            type: 'MeasureDetailRequestedNotification';
            data: MeasureDetailRequestedNotification;
        }

        const handleAirspaceDetailNotification = (notification: IAirspaceDetailRequestedNotification) =>
            ShowTvDetailEvent.fireEvent(notification.data.id);
        const handleFlightDetailNotification = (notification: IFlightDetailRequestedNotification) =>
            context.unityRequests.showFlightDetailFromUnity(notification.data.id);
        const handleMeasureDetailNotification = (notification: IMeasureDetailRequestedNotification) =>
            ModalHandler.showRegulationEditor(notification.data.id, 'reg');

        context.unityNotificationListener.register(
            'AirspaceDetailRequestedNotification',
            handleAirspaceDetailNotification,
        );
        context.unityNotificationListener.register('FlightDetailRequestedNotification', handleFlightDetailNotification);
        context.unityNotificationListener.register(
            'MeasureDetailRequestedNotification',
            handleMeasureDetailNotification,
        );

        return () => {
            context.unityNotificationListener.unregister(
                'AirspaceDetailRequestedNotification',
                handleAirspaceDetailNotification,
            );
            context.unityNotificationListener.unregister(
                'FlightDetailRequestedNotification',
                handleFlightDetailNotification,
            );
            context.unityNotificationListener.unregister(
                'MeasureDetailRequestedNotification',
                handleMeasureDetailNotification,
            );
        };
    }, []);

    useEffect(() => {
        if (!isLoaded) {
            return;
        }

        context.unityRequests.sendStoredUnityRequests();
    }, [isLoaded]);

    return (
        <>
            {!context.isMapless && (
                <UnityCanvas customControls={props.customControls} setIsLoaded={setIsLoaded}></UnityCanvas>
            )}
            <VuplexIntegration setIsLoaded={setIsLoaded}></VuplexIntegration>
            {props.children}
        </>
    );
};
